import { apiUrl as API_BASE_URL } from 'config';
import UserProfile from "components/UserProfile/UserProfile";
import axios from 'axios';

// Create an axios instance with a base URL and authentication header
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('access_token')}` // Assuming JWT auth
  }
});

export const lanesAPI = {
  // Basic CRUD operations for lanes
  getAll: () => api.get('lanes/'),
  getById: (id) => api.get(`lanes/${id}/`),
  create: (data) => api.post('lanes/', data),
  update: (id, data) => api.put(`lanes/${id}/`, data),
  delete: (id) => api.delete(`lanes/${id}/`),

  // Add more custom endpoints as needed
  getAllStatuses: () => api.get('lanes/all-statuses/'),
};

// Add request interceptor to include the token dynamically before each request
api.interceptors.request.use(async (config) => {
  const token = await UserProfile.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;  // Include token in Authorization header
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});
